const unsupportedCSSList = [
  ['inset-inline-start', '20px'],
  ['margin-block-start', '20px'],
] as const;

export const containsUnsupportedCSS = () => {
  for (const [property, value] of unsupportedCSSList) {
    if (!CSS?.supports || CSS.supports(property, value) === false) return true;
  }
  return false;
};
